import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react';
import type { RestaurantFilterProps } from 'components/RestaurantList';
import { DEFAULT_PARAMS_FOR_RESTAURANTS_REQUESTS } from 'utils/constants';

interface SearchUnitsContextData {
  search: string;
  setSearch: Dispatch<SetStateAction<string>>;
  defaultParamsForRestaurants: RestaurantFilterProps;
  setDefaultParamsForRestaurants: Dispatch<
    SetStateAction<RestaurantFilterProps>
  >;
}

export const SearchUnitsContext = createContext({} as SearchUnitsContextData);

interface SearchUnitsContextProviderProps {
  children: ReactNode;
}

export const SearchUnitsContextProvider = ({
  children,
}: SearchUnitsContextProviderProps) => {
  const [search, setSearch] = useState<string>('');
  const [defaultParamsForRestaurants, setDefaultParamsForRestaurants] =
    useState<RestaurantFilterProps>(DEFAULT_PARAMS_FOR_RESTAURANTS_REQUESTS);

  return (
    <SearchUnitsContext.Provider
      value={{
        search,
        setSearch,
        defaultParamsForRestaurants,
        setDefaultParamsForRestaurants,
      }}
    >
      {children}
    </SearchUnitsContext.Provider>
  );
};

export const useSearchUnits = () => {
  const context = useContext(SearchUnitsContext);

  if (!context)
    throw new Error(
      'useSearchUnits must be used within a SearchUnitsContextProvider'
    );

  return context;
};
